<template>
    <nav
        v-if="!navIsHidden"
        id="nav"
        class="navbar-custom bg-white"
    >
        <div class="navbar-custom-inner container-xl p-0 p-lg-5">
            <div
                class="navbar-custom-hamburger"
                @click="mobileActive = !mobileActive"
            >
                <div
                    class="hamburger"
                    v-show="!mobileActive"
                >
                    <hamburger></hamburger>
                    <span>Menu</span>
                </div>
                <div
                    class="cross"
                    v-show="mobileActive"
                >
                    <cross></cross>
                </div>
            </div>
            <div class="navbar-custom-brand">
                <momento-logo></momento-logo>
            </div>
            <div
                v-if="!isHidden"
                class="navbar-custom-menu"
            >
                <router-link
                    to="/"
                    class="navbar-custom-link"
                    exact
                >
                    <div class="navbar-custom-link-inner">Home</div>
                </router-link>
                <router-link
                    to="/jouw-lesdag"
                    class="navbar-custom-link"
                >
                    <div class="navbar-custom-link-inner">Jouw lesdag</div>
                </router-link>
                <router-link
                    to="/planning?tab=Week"
                    class="navbar-custom-link"
                >
                    <div class="navbar-custom-link-inner">Planning</div>
                </router-link>
                <router-link
                    to="/resultaten"
                    class="navbar-custom-link"
                >
                    <div class="navbar-custom-link-inner">Resultaten</div>
                </router-link>
                <router-link
                    to="/notities"
                    class="navbar-custom-link"
                    exact
                >
                    <div class="navbar-custom-link-inner">Notities</div>
                </router-link>
                <router-link
                    to="/documenten"
                    class="navbar-custom-link"
                >
                    <div class="navbar-custom-link-inner">Documenten</div>
                </router-link>
                <router-link
                    v-if="settingsStore.getters.value.momentoAssistantIsEnabled && assistantIsHealthy"
                    to="/momento-assistant"
                    class="navbar-custom-link"
                >
                    <div class="navbar-custom-link-inner">
                        Momento Assistent
                    </div>
                </router-link>
            </div>
        </div>
        <PendingInvites v-if="windowWidth < 1024" />
        <Notifications v-if="windowWidth < 1024" />
        <nav-avatar></nav-avatar>
        <div
            v-show="mobileActive"
            @click="mobileActive = false"
            class="navbar-custom-mobile-backdrop"
        ></div>
        <div
            class="navbar-custom-mobile"
            :class="{ active: mobileActive }"
        >
            <div class="navbar-custom-mobile-inner">
                <div class="brand-wrapper">
                    <div class="brand">
                        <MomentoLogo></MomentoLogo>
                    </div>
                    <div
                        class="cross"
                        @click="mobileActive = false"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="feather feather-x"
                        >
                            <line
                                x1="18"
                                y1="6"
                                x2="6"
                                y2="18"
                            ></line>
                            <line
                                x1="6"
                                y1="6"
                                x2="18"
                                y2="18"
                            ></line>
                        </svg>
                    </div>
                </div>
                <div class="navbar-custom-mobile-menu">
                    <div
                        class="navbar-custom-mobile-link"
                        @click="navigateTo('/')"
                    >
                        <div class="navbar-custom-mobile-link-inner">
                            Home
                            <feather-chevron-right></feather-chevron-right>
                        </div>
                    </div>
                    <div
                        class="navbar-custom-mobile-link"
                        @click="navigateTo('/jouw-lesdag')"
                    >
                        <div class="navbar-custom-mobile-link-inner">
                            Jouw lesdag
                            <feather-chevron-right></feather-chevron-right>
                        </div>
                    </div>
                    <div
                        class="navbar-custom-mobile-link"
                        @click="navigateTo('/planning?tab=Week')"
                    >
                        <div class="navbar-custom-mobile-link-inner">
                            Planning
                            <feather-chevron-right></feather-chevron-right>
                        </div>
                    </div>
                    <div
                        class="navbar-custom-mobile-link"
                        @click="navigateTo('/resultaten')"
                    >
                        <div class="navbar-custom-mobile-link-inner">
                            Resultaten
                            <feather-chevron-right></feather-chevron-right>
                        </div>
                    </div>
                    <div
                        class="navbar-custom-mobile-link"
                        @click="navigateTo('/notities')"
                    >
                        <div class="navbar-custom-mobile-link-inner">
                            Notities
                            <feather-chevron-right></feather-chevron-right>
                        </div>
                    </div>
                    <div
                        class="navbar-custom-mobile-link"
                        @click="navigateTo('/documenten')"
                    >
                        <div class="navbar-custom-mobile-link-inner">
                            Documenten
                            <feather-chevron-right></feather-chevron-right>
                        </div>
                    </div>
                    <div
                        v-if="settingsStore.getters.value.momentoAssistantIsEnabled && assistantIsHealthy"
                        class="navbar-custom-mobile-link"
                        @click="navigateTo('/momento-assistant')"
                    >
                        <div class="navbar-custom-mobile-link-inner">
                            Momento Assistent
                            <feather-chevron-right></feather-chevron-right>
                        </div>
                    </div>
                    <div class="navbar-custom-mobile-dropdown">
                        <label
                            for="group-select"
                            class="navbar-custom-mobile-dropdown-label"
                        >
                            <span>Huidige groep:</span>
                        </label>
                        <v-select
                            id="group-select"
                            label="naam"
                            :options="groups"
                            v-model="selected"
                            :searchable="false"
                            :clearable="false"
                            @close="
                                () => {
                                    $el.querySelector('input[type=search]')?.blur()
                                    mobileActive = false
                                }
                            "
                        >
                            <template #open-indicator="{ attributes }">
                                <span v-bind="attributes">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-chevron-down"
                                    >
                                        <polyline
                                            points="6 9 12 15 18 9"
                                            stroke-width="1"
                                        ></polyline>
                                    </svg>
                                </span>
                            </template>
                            <template v-slot:no-options="{ searching }">
                                <template v-if="searching"> Geen resultaten </template>
                                <em
                                    style="opacity: 0.5"
                                    v-else
                                ></em>
                            </template>
                        </v-select>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</template>
<script lang="ts" setup>
import { computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import Cross from '@/components-svg/Cross.vue'
import FeatherChevronRight from '@/components-svg/FeatherChevronRight.vue'
import Hamburger from '@/components-svg/Hamburger.vue'
import MomentoLogo from '@/components-svg/MomentoLogo.vue'
import NavAvatar from '@/components/Nav-Avatar.vue'
import { useStore } from '@/composables/useStore'
import { Yeargroup } from '@/enums/Yeargroup'
import { IGroup } from '@/interfaces/IGroup'
import { assistantService } from '@/services/assistantService'
import { useWindowSize } from '@vueuse/core'
import { onMounted } from 'vue'
import Notifications from './Notifications.vue'
import PendingInvites from './PendingInvites.vue'

const route = useRoute()
const router = useRouter()

const { notesStore, groupStore, userStore, resultsStore, settingsStore } = useStore()
const { width: windowWidth } = useWindowSize()

const mobileActive = ref(false)
const assistantIsHealthy = ref(false)

// Only offer the assistant when it is reachable
onMounted(async () => {
    assistantIsHealthy.value = await assistantService.isHealthy()
})

const isHidden = computed(() => {
    return (
        route.matched.findIndex((route) => {
            return route.path === '/onboarding' || route.path === '/planning/aanpassen'
        }) > -1
    )
})

const navIsHidden = computed(() => {
    return (
        route.matched.findIndex((route) => {
            return route.path === '/login' || route.path === '/digibord' || route.path.startsWith('/widget/moo')
        }) > -1
    )
})

const unreadNotesCount = computed(() => {
    return notesStore.getters.value.getUnreadNotesCount
})

const onOpenNotifications = () => {
    notesStore.commits.setShowUnread(true)
    navigateTo('/notities')
}

const navigateTo = (path: string) => {
    router.push({ path: path })
    mobileActive.value = false
}

const groups = computed<IGroup[]>(() => {
    const gr = groupStore.getters.value.groups
    return gr.sort((a: IGroup, b: IGroup) => a.naam.localeCompare(b.naam))
})

const selected = computed({
    get() {
        return groupStore.getters.value.getSelectedGroup
    },
    set(group: IGroup) {
        localStorage.removeItem('selectedYeargroups')
        groupStore.commits.setSelectedGroup(group)
        userStore.commits.setUserSettings({ groep: group.id })
        groupStore.actions.getCandidates(group.id)
        resultsStore.commits.setFilters({ YeargroupFilter: Yeargroup.ALLE })
        userStore.actions.setUserSettings()
        groupStore.actions.getGroupSettings(group.id)
        notesStore.actions.getUnread()
        notesStore.actions.getUnreadNotes()
    },
})
</script>
